[
    {
        "id": "sandbox",
        "name": "SANDBOX",
        "mapIds": ["garage", "basement", "small-colo", "small-campus"]
    },
    {
        "id": "fj1_garage_to_glory",
        "name": "Act 1 · Garage to Glory",
        "mapIds": ["garage", "basement", "small-colo", "small-campus"]
    },
    {
        "id": "scenario_arm_race",
        "name": "The ARM Race",
        "mapIds": ["garage", "basement", "small-colo", "small-campus"]
    },
    {
        "id": "scenario_garage_to_glory_hard",
        "name": "Garage to Glory: Hard",
        "mapIds": ["garage", "basement", "small-colo", "small-campus"]
    }
]
